// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://core.api.dareup.app';

export const API_ENDPOINTS = {
    WAITLIST_SUBMIT: `${API_BASE_URL}/waitlist/submit`,
    WAITLIST_STATS: `${API_BASE_URL}/waitlist/stats`,
};
